import { Modal, Form, Row, Col, Input, Button } from "antd";
import { useModalEstado } from "../../../hooks/useModalEstado";

interface IModalCodigos {
  openModal: boolean;
  setOpenModal: Function;
}

export const ModalEstado = ({
  openModal,
  setOpenModal
}: IModalCodigos): any => {
  const {
    actualizarEstado,
    setCodigoPropuesta,
    codigoPropuesta,
    estado,
    setEstado,
    numeroDocumento,
    setNumeroDocumento
  } = useModalEstado()

  const fields = [
    { name: "codigoPropuesta", value: codigoPropuesta },
    { name: "numeroDocumento", value: numeroDocumento },
    { name: "estado", value: estado },
  ];

  const handleInputChangeCodigo = (e) => {
    setCodigoPropuesta(e.target.value);
  };

  const handleInputChangeId = (e) => {
    setNumeroDocumento(e.target.value);
  };

  const handleInputChangeType = (e) => {
    setEstado(e.target.value);
  };

  // @ts-ignore
  return (
    <Modal
      maskStyle={{
        backgroundColor: "rgba(31,174,239,0.8)",
        borderRadius: "6px",
      }}
      title="Gestionar estado de las postulaciones"
      visible={openModal}
      onCancel={() => setOpenModal(!openModal)}
      width={window.innerWidth * 0.5}
      footer={
        <Row justify="end" gutter={[24, 24]}>
          <Col>
            <Button
              className="button-gray-ghost"
              onClick={() => window.location.reload()}
            >
              Cerrar
            </Button>
          </Col>
          <Col className="justify-content-flex-end">
            <Button
              className="button-azul-radius"
              htmlType="submit"
              form="modalEstado"
            >
              Actualizar estado
            </Button>
          </Col>
        </Row>
      }
    >
      <Form
        fields={fields}
        name="modalEstado"
        onFinish={() => actualizarEstado()}
      >
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <Form.Item
              className="no-margin"
              name="codigoPropuesta"
              rules={[{ required: true, message: "" }]}
            >
              <Input onChange={handleInputChangeCodigo} placeholder="Código de propuesta" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              className="no-margin"
              name="numeroDocumento"
              rules={[{ required: true, message: "" }]}
            >
              <Input onChange={handleInputChangeId} placeholder="Número de documento" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              className="no-margin"
              name="tipoP"
              rules={[{ required: true, message: "" }]}
            >
              <Input onChange={handleInputChangeType} placeholder="Estado" />
            </Form.Item>
          </Col>
          <br />
          { setEstado && (
            <div>
              Se actualiza el estado de propuesta <span style={{fontWeight: 'bold'}}>{codigoPropuesta}</span> con el estado : <span style={{fontWeight: 'bold'}}>{setEstado}</span>
            </div>
          )}
        </Row>
      </Form>
    </Modal>
  );
};
